<template>
  <div class="agreement-input">
    <fieldset class="form-group">
      <div class="row">
        <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <div
            class="form-check"
            :class="{ 'form-check-inline': options.inline }">
            <input type="radio" value="1"
              class="form-check-input"
              id="yes"
              :name="options.name"
              :checked="value"
              @change="validate($event.target.value)"/>
            <label class="form-check-label" for="yes">
            {{ options.agree }}
            </label>
          </div>
          <div
            class="form-check"
            :class="{ 'form-check-inline': options.inline }">
            <input type="radio" value="0"
              class="form-check-input"
              id="no"
              :name="options.name"
              :checked="!value"
              @change="validate($event.target.value)"/>
            <label class="form-check-label" for="no">
            {{ options.disagree }}
            </label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'AgreementInput',
  props: {
    value: {
      type: Boolean
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false
    }
  },
  computed: {
    validationClass,
    validationMessage
  },
  methods: {
    validate (val = this.value) {
      if (!isNaN(parseInt(val))) {
        val = Boolean(parseInt(val))
      }
      this.$emit('input', val)
      this.isDirty = true
      this.isValid = val
      if (!this.options.required) {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AgreementInput.vue